"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AbstractComponentStore = /** @class */ (function () {
    function AbstractComponentStore() {
    }
    return AbstractComponentStore;
}());
exports.default = AbstractComponentStore;
